import React from 'react';

function Travel() {

    return (
        <div>
           <div className="wedding">
            <img alt="travel-header" src='/parallax/pngegg (15).png' className="header"   />
            <br />
            <br />
            <h1>ACCOMODATIONS</h1>
            <div style={{
                paddingLeft: 20,
                paddingRight: 20
            }}>
            <br />
            <h3>Whispering Springs</h3>
            <p>Only a couple Luxury Tents left available on site!
            </p>
            <p>Wedding prices range from $250-400</p>
            <p>Please text Lizzy (519-580-7736) or Luke (519-533-8637) to book.</p>
            <p>141 Mercer Lane, Grafton, Ontario</p>
            <a href="https://www.whisperingsprings.ca/choose-your-tent">Luxury Tents</a>
            <br />
            <a href="https://static1.squarespace.com/static/5cd507b59d4149657d1ed6bc/t/5ee2da3e31781f54f1836a49/1591925331450/WS+Map.pdf">Site Map</a>
            <br />
            <a href="https://www.whisperingsprings.ca">Visit Website</a>
            </div>
            <br />
            <br />
            <br />
            <h3>Cobourg Comfort Inn</h3>
            <p>121 Densmore Rd, Cobourg, Ontario</p>
            <a href="https://www.choicehotels.com/ontario/cobourg/comfort-inn-hotels/cn263/rates?gal=undefined&gmp=MetaOrganic&gpa=GPADSAPR1&hmGUID=1627fdc4-5dc0-4674-b376-e59f8e680144&mc=HAGOCGCA&meta=PMFGPADCASAPR1_CN263_localuniversal_CA_1_desktop_2023-06-09_selected___organic&pmf=hpagoogleca&product=localuniversal&ratePlanCode=SAPR1&adults=2&checkInDate=2023-06-09&checkOutDate=2023-06-10">Visit Website</a>
            <br />
            <br />
            <br />
            <h3>Colborne Guest House</h3>
            <p>60 Toronto Street, Colborne, Ontario</p>
            <a href="https://www.colborneguesthouse.ca">Visit Website</a>
        </div>
            <br />
            <br />
            <br />
            <img  alt="top-vine" className="top-vine" src='assets/Frame 2 (6).svg' />
        </div>
    )
}

export default Travel;